<template>
  <a-button
    :type="config.type || 'primary'"
    :size="config.size || 'middle'"
    @click="$emit('component-event', { name: 'button-clicked', config })"
  >
    {{ config.text }}
  </a-button>
</template>
<script>
import { defineComponent } from 'vue'
import { props } from './helper'

export default defineComponent({
  props,
  emits: ['component-event'],
  setup () {
    return {}
  }
})
</script>
<style lang="less" scoped></style>
